import axios from "axios";
import { fontMachine } from "../../branding/components/fontMachine.js";
import { mapState } from "vuex";
import { log } from "console";
import RecommendedUpgrade from "@/views/adminPanel/pages/dashboard/components/RecommendedUpgrade.vue";
import ExploreWeb3 from "@/views/adminPanel/pages/dashboard/components/ExploreWeb3.vue";
import MyResources from "@/views/adminPanel/pages/dashboard/components/MyResources.vue";
export const CampaignStatuslogic = {
  data() {
    return {
      isshowCampaignPopup: false,
      isShowContentEdit: false,
      subtitle: "",
      title: "",
      layoutPriview: "",
      // layoutPriview: {
      //   img: "",
      //   id: "",
      // },
      eventsCard: [],
      Platform: "Instagram",
      Heading: "",
      id: null,
      Paragraph: "",
      Website: "",
      Email: "",
      Primary: "",
      Secondary: "",
      Logo: "",
      Image: "",
      Posts: "",

      isShowContentEdit: false,
      description: "",

      layout: [],
      canvas: "",
      parentIndex: null,
      isShowImage: "",
      LogoMedia: "",
      ImageMedia: "",
      brand: "",
      ParagraphFont: "",
      primaryFont: "",
      Postslinkedin: [],
      PostsWhatsapp: [],
      PostsTwitter: [],
      PostsStories: [],
      centerDialogVisibleprimaryMedia: false,
      centerDialogVisibleprimaryImage: false,
      imgCollection: [
        {
          id: "01",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/imageLayouts/1.png",
        },
      ],
      mediaCollection: [
        {
          id: "01",
          img: "https://demos.pixinvent.com/vuexy-vuejs-admin-template-vue2/demo-1/img/04.50dac1e3.jpg",
        },
      ],
      isShowImage: "",
      description: "",
      isShowCampaign: false,
      selectedCampaign: "",
      Campaignoptions: [
        {
          value: "SMS-Campaign",
          label: "SMS",
        },
        {
          value: "email-Campaign",
          label: "Email",
        },
        {
          value: "pushNotification-Campaign",
          label: "Push Notification",
        },
        {
          value: "whatsapp-Campaign",
          label: "Whats App",
        },
      ],
      componentKey: 0,
      month: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      day: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      url: this.$imageURL,
      Coords_image: [null, null],
      rotation_image: [0, 0],
      Coords_text: [null, null, null, null],
      FetchedLayout: null,
      Colorchanged: false,
      InstagramTemplate: [],
      LinkedInTemplate: [],
      TwitterTemplate: [],
      StoriesTemplate: [],
      postData: [],
      Templatemap: {
        Instagram: "InstagramTemplate",
        LinkedIn: " LinkedInTemplate",
        Twitter: "TwitterTemplate",
        Stories: "StoriesTemplate",
      },
      isCanvasSupplied: false,
      isPlatformchanged: true,
      timeout: "",
      text1Color: "#000000",
      text2Color: "#000000",
      text3Color: "#000000",
      text4Color: "#000000",
      Prompt: "",
      isPromptDisabled: true,
      PromptPattern: /^\s*\w+(\s+\w+)?\s*$/,
      currentStep: 1,
      OnlineImages: [],
      OnlineSelectedImages: [],
      search: "",
      PostsAlreadyexsists: false,
      ShowPopup: true,
      ParagraphFont: "",
      primaryFont: "",
      fetchLayout: false,
      ColoredLayout: "",
      Layoutid: "",
      PreviousLayoutIds: [""],
      NewLayoutIds: [],
      svgStrings: [],
      isSvgupdating: false,
      PopulatingCanvas: true,
      Prevcanvas: "",
      NoUpcoming: false,
    };
  },
  watch: {
    layoutSelected() {
      this.componentKey += 1;
      this.setLayout();
    },
    Prompt(newValue) {
      if (newValue == "") {
        this.isPromptDisabled = true;
      } else {
        if (this.PromptPattern.test(newValue)) {
          this.isPromptDisabled = false;
        } else {
          this.Prompt = this.Prompt.split(/\s+/).slice(0, 2).join(" ");
          this.$swal({
            title: "Warning",
            text: `More than two words not allowed`,
            customClass: {
              container: "my-sweetalert-container",
            },
            icon: "warning",
            timer: 2000,
            buttons: false,
          });
        }
      }
    },

    async isShowContentEdit(newValue) {
      // if (newValue == true) {
      //   if (this.PostsAlreadyexsists) {
      //     if (this.currentStep < 2) {
      //       this.currentStep++;
      //     }
      //     this.PostsAlreadyexsists = false;
      //   } else {
      //     this.RequestToPixabay();
      //   }
      // }
    },

    async isShowImage(newValue) {
      if (this.isCanvasSupplied) {
        // (this.Coords_image = [null, null]),
        //   (this.Coords_text = [null, null, null, null]),
        //   (this.rotation_image = [0, 0]),
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.isShowImage) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },

    async ImageMedia(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.ImageMedia) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async LogoMedia(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.LogoMedia) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async text1Color(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.text1Color) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async text2Color(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.text2Color) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async text3Color(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.text3Color) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async text4Color(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.text4Color) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },

    events() {
      this.InstagramTemplate = [];
      this.LinkedInTemplate = [];
      this.TwitterTemplate = [];
      this.StoriesTemplate = [];
      this.PreviewTemplate();
      this.getEvents();
    },
    async Platform(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.Platform) {
            this.isShowImage = eval(`this.${this.Templatemap[this.Platform]}`);

            await this.PopulatePreview();
          }
        }, 1000);
      }
    },

    async Heading(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.Heading) {
            this.Heading = newValue.trim();
            console.log(newValue, "new");
            await this.PopulatePreview();
          }
        }, 1000);
        // await this.PopulatePreview();
      }
    },
    async Paragraph(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.Paragraph) {
            this.Paragraph = newValue.trim();
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async Website(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.Website) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async Email(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.Email) {
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async ParagraphFont(newValue) {
      //if (this.isCanvasSupplied) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (newValue === this.ParagraphFont) {
          try {
            await fontMachine([this.ParagraphFont]);
          } catch (error) {
            console.log("error");
          }

          await this.PopulatePreview();
        }
      }, 1000);
      // }
    },
    async primaryFont(newValue) {
      //  if (this.isCanvasSupplied) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (newValue === this.primaryFont) {
          try {
            await fontMachine([this.primaryFont]);
          } catch (error) {
            console.log("error");
          }

          await this.PopulatePreview();
        }
      }, 1000);
      // }
    },
    async Primary(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.Primary) {
            this.Colorchanged = true;
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
    async Secondary(newValue) {
      if (this.isCanvasSupplied) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (newValue === this.Secondary) {
            this.Colorchanged = true;
            await this.PopulatePreview();
          }
        }, 1000);
      }
    },
  },

  computed: {
    ...mapState("brandProfile", [
      "brandProfile",
      "layoutSelected",
      "googleFontFamily",
      "ailimit",
    ]),
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("user", ["selectedProject"]),
  },
  async mounted() {
    await this.getEvents();
    // await this.setLayout();
    await this.PopulatePreview();

    // await this.PreviewCanvas();
    let data = await axios.post(
      process.env.VUE_APP_SVG_DATAENTRY + "/Templates" + "/Read"
    );

    this.imgCollection = data.data.response;

    this.PreviewTemplate();

    let mediaData = await axios.post(
      process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
      {},
      {
        headers: {
          "community-name": process.env.VUE_APP_COMMUNITY_NAME,
        },
      }
    );

    this.mediaCollection = mediaData.data;

    // this.timeout = setTimeout(async () => {

    // }, 1000);
    console.log("mount");
  },
  methods: {
    async closeDialog() {
      // this.isShowContentEdit = false;
      // this.PopulatingCanvas = true;
      await this.PreviewCanvas();

      console.log("close");
    },
    shareImage(url) {
      console.log(url, "Postsurl");
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "posts.jpg";

          downloadLink.click();
          URL.revokeObjectURL(downloadLink.href);
          downloadLink.remove();
        })
        .catch((error) => {
          console.error("Error downlaoding file:", error);
        });
    },
    async nextStep() {
      if (this.currentStep < 2) {
        this.ShowPopup = false;

        for (let i = 0; i <= this.OnlineSelectedImages.length - 1; i++) {
          await this.SaveUsingRemote(this.OnlineSelectedImages[i]);
        }
        setTimeout(() => {
          if (!this.ImageMedia.link || this.ImageMedia == "") {
            this.ImageMedia = { link: this.mediaCollection[0].link };
            if (!this.ImageMedia["id"]) {
              this.ImageMedia["_id"] = this.mediaCollection[0]._id;
            }
          }
        }, 1000);

        this.currentStep++;
        setTimeout(() => {
          this.ShowPopup = true;
        }, [5000]);
        if (this.isCanvasSupplied) {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            await this.PreviewCanvas();
          }, 1000);
        }
      } else {
        for (let i = 0; i <= this.OnlineSelectedImages.length - 1; i++) {
          await this.SaveUsingRemote(this.OnlineSelectedImages[i]);
        }
        if (this.ImageMedia.link) {
          this.ImageMedia = { link: this.mediaCollection[0].link };
          if (!this.ImageMedia["id"]) {
            this.ImageMedia["_id"] = this.mediaCollection[0]._id;
          }
        }
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    submitForm() {
      // Here, you can handle form submission and send data to your server.
      // For this example, we'll just log the form data.
      console.log("Form data:", this.formData);
    },
    handleClick() {
      this.$router.push({ name: this.selectedCampaign });
    },
    convertXandy(ow, oh, x, y, cw, ch) {
      return [(x / ow) * cw, (y / oh) * ch];
    },
    converter(image, text, ow, oh, cw, ch) {
      let imageCoors = [];
      let textCoors = [];
      for (let i = 0; i <= image.length - 1; i++) {
        imageCoors.push(
          this.convertXandy(ow, oh, image[i]["x"], image[i]["y"], cw, ch)
        );
      }
      for (let i = 0; i <= text.length - 1; i++) {
        textCoors.push(
          this.convertXandy(ow, oh, text[i]["x"], text[i]["y"], cw, ch)
        );
      }
      return [imageCoors, textCoors];
    },

    async PreviewCanvas() {
      window.addEventListener("resize", this.PreviewCanvas);
      // await fontMachine([this.primaryFont, this.ParagraphFont]);
      let canvasWidth = null;
      let canvasHeight = null;
      let originalWidth = null;
      let originalHeight = null;
      let zoomWidth = null;
      let zoomHeight = null;
      if (this.Platform == "Instagram") {
        canvasWidth = 1080;
        canvasHeight = 1080;
        zoomWidth = 295;
        zoomHeight = 295;
        originalWidth = 1080;
        originalHeight = 1080;
      } else if (this.Platform == "LinkedIn") {
        canvasWidth = 1200;
        canvasHeight = 628;
        zoomWidth = 666.7;
        zoomHeight = 350.37;
        originalWidth = 1200;
        originalHeight = 628;
      } else if (this.Platform == "Twitter") {
        canvasWidth = 1280;
        canvasHeight = 720;
        zoomWidth = 711.11;
        zoomHeight = 400;
        originalWidth = 1280;
        originalHeight = 720;
      } else if (this.Platform == "Stories") {
        canvasWidth = 600;
        canvasHeight = 1066.67;
        zoomWidth = 335;
        zoomHeight = 1066.67;
        originalWidth = 1080;
        originalHeight = 1920;
      }

      try {
        this.canvas.dispose();
      } catch (error) {}

      if (
        this.FetchedLayout == null ||
        this.FetchedLayout["response"][0]["id"] != this.isShowImage.id ||
        this.Colorchanged == true
      ) {
        let { data } = await axios
          .post(process.env.VUE_APP_SVG_DATAENTRY + "/Templates" + "/Readone", {
            id: this.isShowImage.id,
            primary: this.Primary,
            secondary: this.Secondary,
          })
          .then((response) => {
            return response;
          });
        this.FetchedLayout = data;
        this.Colorchanged = false;
      }

      const imageid = ["imageid1", "imageid2"];
      const textid = ["text1", "text2", "text3", "text4"];
      // let imageLength = data["response"][0]["image"].length;
      let image = this.FetchedLayout["response"][0]["image"];
      // console.log(image, "image");
      // let textLength = data["response"][0]["text"].length;
      let text = this.FetchedLayout["response"][0]["text"];
      // console.log(data["response"][0], "data");
      let svgString = this.FetchedLayout["response"][0]["svg"];
      let canvasId = "my-canvas1";
      this.canvas = new fabric.Canvas(canvasId, {
        width: originalWidth,
        height: originalHeight,
        preserveObjectStacking: true,
      });

      let scalex = zoomWidth / originalWidth;
      let scaley = zoomHeight / originalHeight;
      let scaleratio = Math.min(scalex, scaley);
      const zoomX = zoomWidth / originalWidth;
      const zoomY = zoomHeight / originalHeight;

      const zoomWindowWidth = window.innerWidth * zoomX;
      const zoomWindowHeight = window.innerHeight * zoomY;
      console.log(zoomWindowWidth, zoomWindowHeight, "dimension");
      let zoomFactor = Math.min(
        zoomWindowWidth / originalWidth,
        zoomWindowHeight / originalHeight
      );

      this.canvas.setZoom(zoomFactor);
      let Coords = this.converter(
        image,
        text,
        originalWidth,
        originalHeight,
        canvasWidth,
        canvasHeight
      );
      let imageCoords = Coords[0];
      let textCoords = Coords[1];

      // const x = 48;
      // const y = 1012;

      // const convertedX = (x / originalWidth) * canvasWidth;
      // const convertedY = (y / originalHeight) * canvasHeight;
      const text1 = new fabric.Text(this.Heading, {
        left:
          this.Coords_text[0] != null
            ? this.Coords_text[0]["x"]
            : textCoords[0][0],
        top:
          this.Coords_text[0] != null
            ? this.Coords_text[0]["y"]
            : textCoords[0][1],
        id: "text1",
        // fontFamily: this.primaryFont,
        fill: this.text1Color,
        fontFamily: this.primaryFont,
        fontSize:
          this.Coords_text[0] != null
            ? this.Coords_text[0]["size"]
            : text[0]["size"],
      });
      const text2 = new fabric.Text(this.Paragraph, {
        left:
          this.Coords_text[1] != null
            ? this.Coords_text[1]["x"]
            : textCoords[1][0],
        top:
          this.Coords_text[1] != null
            ? this.Coords_text[1]["y"]
            : textCoords[1][1],
        id: "text2",
        // fontFamily: this.ParagraphFont,
        fontFamily: this.ParagraphFont,
        fill: this.text2Color,
        fontSize:
          this.Coords_text[1] != null
            ? this.Coords_text[1]["size"]
            : text[1]["size"],
      });
      const text3 = new fabric.Text(this.Website, {
        left:
          this.Coords_text[2] != null
            ? this.Coords_text[2]["x"]
            : textCoords[2][0],
        top:
          this.Coords_text[2] != null
            ? this.Coords_text[2]["y"]
            : textCoords[2][1],
        id: "text3",
        // fontFamily: this.ParagraphFont,
        fontFamily: this.ParagraphFont,
        fill: this.text3Color,
        fontSize:
          this.Coords_text[2] != null
            ? this.Coords_text[2]["size"]
            : text[2]["size"],
      });
      const text4 = new fabric.Text(this.Email, {
        left:
          this.Coords_text[3] != null
            ? this.Coords_text[3]["x"]
            : textCoords[3][0],
        top:
          this.Coords_text[3] != null
            ? this.Coords_text[3]["y"]
            : textCoords[3][1],
        id: "text4",
        // fontFamily: this.ParagraphFont,
        fill: this.text4Color,
        fontFamily: this.ParagraphFont,
        fontSize:
          this.Coords_text[3] != null
            ? this.Coords_text[3]["size"]
            : text[3]["size"],
      });

      // this.canvas.bringToFront(text1);
      // this.canvas.bringToFront(text2);

      // this.canvas.bringToFront(text3);

      // this.canvas.bringToFront(text4);
      let lockobjprev = {
        lockMovementX: true,
        lockMovementY: true,
        lockScalingX: true,
        lockScalingY: true,
        lockScalingY: true,
        lockRotation: true,
        selectable: false,
      };
      let lockobj = {
        lockRotation: true,
      };

      text1.set(lockobjprev);
      text2.set(lockobjprev);
      text3.set(lockobjprev);
      text4.set(lockobjprev);
      this.canvas.add(text1, text2, text3, text4);

      if (this.ImageMedia.link) {
        let imageWidthRelativeToFrame = image[1]["width"];
        let imageHeightRelativeToFrame = image[1]["height"];
        let scaleX = canvasWidth / originalWidth;
        let scaleY = canvasHeight / originalHeight;
        let imageWidthonCanvas = imageWidthRelativeToFrame * scaleX;
        let imageHeightonCanvas = imageHeightRelativeToFrame * scaleY;
        const imgelement1 = document.createElement("img");
        imgelement1.src = this.url + "/" + this.ImageMedia.link;
        imgelement1.onload = () => {
          let fabricImg = new fabric.Image(imgelement1, {
            left:
              this.Coords_image[1] != null
                ? this.Coords_image[1]["x"]
                : imageCoords[1][0],
            top:
              this.Coords_image[1] != null
                ? this.Coords_image[1]["y"]
                : imageCoords[1][1],
            id: "Image1",
          });
          let w =
            this.Coords_image[1] != null
              ? this.Coords_image[1]["width"]
              : imageWidthonCanvas;
          let h =
            this.Coords_image[1] != null
              ? this.Coords_image[1]["height"]
              : imageHeightonCanvas;
          fabricImg.scaleToWidth(w);
          fabricImg.scaleToHeight(h);
          fabricImg.rotate(this.rotation_image[1]);
          fabricImg.set(lockobjprev);
          this.canvas.add(text1, text2, text3, text4);
          this.canvas.add(fabricImg);
        };
        // let image2 = new fabric.Image.fromURL(
        //   this.url + "/" + this.ImageMedia.link,
        //   (img) => {
        //     img.scaleToWidth(imageWidthonCanvas);
        //     img.scaleToHeight(imageHeightonCanvas);
        //     img.set({
        //       left: imageCoords[1][0],
        //       top: imageCoords[1][1],
        //       objectCaching: false,
        //     });
        //     this.canvas.add(text1, text2, text3, text4);
        //     this.canvas.add(img);
        //   }
        // );
      }

      if (this.LogoMedia.link) {
        let imageWidthRelativeToFrame = image[0]["width"];
        let imageHeightRelativeToFrame = image[0]["height"];
        let scaleX = canvasWidth / originalWidth;
        let scaleY = canvasHeight / originalHeight;
        let imageWidthonCanvas = imageWidthRelativeToFrame * scaleX;
        let imageHeightonCanvas = imageHeightRelativeToFrame * scaleY;
        const imgelement = document.createElement("img");
        imgelement.src = this.url + "/" + this.LogoMedia.link;
        imgelement.onload = () => {
          let fabricImg = new fabric.Image(imgelement, {
            left:
              this.Coords_image[0] != null
                ? this.Coords_image[0]["x"]
                : imageCoords[0][0],
            top:
              this.Coords_image[0] != null
                ? this.Coords_image[0]["y"]
                : imageCoords[0][1],
            id: "Image2",
          });
          let w =
            this.Coords_image[0] != null
              ? this.Coords_image[0]["width"]
              : imageWidthonCanvas;
          let h =
            this.Coords_image[0] != null
              ? this.Coords_image[0]["height"]
              : imageHeightonCanvas;
          fabricImg.rotate(this.rotation_image[0]);
          fabricImg.scaleToWidth(w);
          fabricImg.scaleToHeight(h);
          fabricImg.set(lockobjprev);
          this.canvas.add(text1, text2, text3, text4);
          this.canvas.add(fabricImg);
        };
        // let image1 = new fabric.Image.fromURL(
        //   this.url + "/" + this.LogoMedia.link,
        //   (img) => {
        //     img.scaleToWidth(imageWidthonCanvas);
        //     img.scaleToHeight(imageHeightonCanvas);
        //     img.set({
        //       left: imageCoords[0][0],
        //       top: imageCoords[0][1],
        //       objectCaching: false,
        //     });
        //     this.canvas.add(text1, text2, text3, text4);
        //     // this.canvas.add(text1, text2, text3, text4);
        //     this.canvas.add(img);
        //   }
        // );
      }

      fabric.loadSVGFromString(svgString, (objects, options) => {
        const svg = fabric.util.groupSVGElements(objects, options);
        svg.set({
          left: 0,
          top: 0,

          lockMovementX: true,
          lockMovementY: true,
          lockScalingX: true,
          lockScalingY: true,
          lockScalingY: true,
          lockRotation: true,
          selectable: false,
        });

        // svg.scale(scaleratio);
        this.canvas.add(svg);
        this.canvas.sendToBack(svg);
      });

      this.canvas.renderAll();
      this.canvas.on("object:moving", (event) => {
        const target = event.target;

        if (target instanceof fabric.Image) {
          if (target.id == "Image1") {
            this.Coords_image[1] = {
              x: target.left,
              y: target.top,
              width: target.getScaledWidth(),
              height: target.getScaledHeight(),
            };
          }
          if (target.id == "Image2") {
            this.Coords_image[0] = {
              x: target.left,
              y: target.top,
              width: target.getScaledWidth(),
              height: target.getScaledHeight(),
            };
          }
        } else if (target instanceof fabric.Text) {
          if (target.id == "text1") {
            this.Coords_text[0] = {
              x: target.left,
              y: target.top,
              size: parseInt(target.fontSize),
            };
          }
          if (target.id == "text2") {
            this.Coords_text[1] = {
              x: target.left,
              y: target.top,
              size: parseInt(target.fontSize),
            };
          }
          if (target.id == "text3") {
            this.Coords_text[2] = {
              x: target.left,
              y: target.top,
              size: parseInt(target.fontSize),
            };
          }
          if (target.id == "text4") {
            this.Coords_text[3] = {
              x: target.left,
              y: target.top,
              size: parseInt(target.fontSize),
            };
          }
          console.log(target.id);
        }
      });
      this.canvas.on("object:scaling", async (event) => {
        const target = event.target;

        if (target instanceof fabric.Image) {
          console.log(target.id);
          if (target.id == "Image1") {
            let scaleX = target.scaleX;
            let scaleY = target.scaleY;
            this.Coords_image[1] = {
              x: target.left,
              y: target.top,
              width: target.width,
              height: target.height,
            };
            // let originalWidth = target.getOriginalSize().width;
            // let originalHeight = target.getOriginalSize().height;
            // let newWidth = originalWidth * scaleX;
            // let newHeight = originalHeight * scaleY;
            this.Coords_image[1]["width"] = target.getScaledWidth();
            this.Coords_image[1]["height"] = target.getScaledHeight();
            // if (newWidth > newHeight) {
            // target.scaleToWidth(target.getScaledWidth());
            // } else {
            // target.scaleToHeight(target.getScaledHeight());

            // }
            // await this.PreviewCanvas();
          }
          if (target.id == "Image2") {
            let scaleX = target.scaleX;
            let scaleY = target.scaleY;
            this.Coords_image[0] = {
              x: target.left,
              y: target.top,
              width: target.width,
              height: target.height,
            };
            // let originalWidth = target.getOriginalSize().width;
            // let originalHeight = target.getOriginalSize().height;
            // let newWidth = originalWidth * scaleX;
            // let newHeight = originalHeight * scaleY;
            this.Coords_image[0]["width"] = target.getScaledWidth();
            this.Coords_image[0]["height"] = target.getScaledHeight();
            // if (newWidth > newHeight) {
            // target.scaleToWidth(target.getScaledWidth());
            // } else {
            // target.scaleToHeight(target.getScaledHeight());

            // }
            // await this.PreviewCanvas();
          }
        } else if (target instanceof fabric.Text) {
          if (target.id == "text1") {
            let scale = target.scaleX;
            // console.log(scale);
            // console.log(this.Coords_text);
            this.Coords_text[0] = {
              x: target.left,
              y: target.top,
              size: parseInt(target.fontSize),
            };
            console.log(scale);

            this.Coords_text[0]["size"] *= scale;
            console.log(this.Coords_text[0]["size"]);
            target.fontSize = parseInt(target.fontSize) * scale;
            this.Coords_text[0]["x"] = target.left;
            this.Coords_text[0]["y"] = target.top;
            target.scaleX = 1;
            target.scaleY = 1;
          }
          if (target.id == "text2") {
            let scale = target.scaleX;
            this.Coords_text[1] = {
              x: target.left,
              y: target.top,
              size: parseInt(target.fontSize),
            };

            this.Coords_text[1]["size"] *= scale;
            target.fontSize = parseInt(target.fontSize) * scale;
            this.Coords_text[1]["x"] = target.left;
            this.Coords_text[1]["y"] = target.top;
            target.scaleX = 1;
            target.scaleY = 1;
          }
          if (target.id == "text3") {
            let scale = target.scaleX;
            this.Coords_text[2] = {
              x: target.left,
              y: target.top,
              size: parseInt(target.fontSize),
            };
            this.Coords_text[2]["size"] *= scale;
            target.fontSize = parseInt(target.fontSize) * scale;
            this.Coords_text[2]["x"] = target.left;
            this.Coords_text[2]["y"] = target.top;
            target.scaleX = 1;
            target.scaleY = 1;
          }
          if (target.id == "text4") {
            let scale = target.scaleX;
            this.Coords_text[3] = {
              x: target.left,
              y: target.top,
              size: parseInt(target.fontSize),
            };
            this.Coords_text[3]["size"] *= scale;
            target.fontSize = parseInt(target.fontSize) * scale;
            this.Coords_text[3]["x"] = target.left;
            this.Coords_text[3]["y"] = target.top;
            target.scaleX = 1;
            target.scaleY = 1;
          }
          console.log(target.id);
        }
      });
      this.canvas.on("object:rotating", (event) => {
        const target = event.target;
        if (target instanceof fabric.Image) {
          console.log(target.id);
          if (target.id == "Image1") {
            this.rotation_image[1] = target.angle;
            target.rotate(target.angle);
          }
          if (target.id == "Image2") {
            this.rotation_image[0] = target.angle;
            target.rotate(target.angle);
          }
        }
      });
    },
    biasedRandom(size) {
      var random = Math.floor(Math.random() * (size - 0) + 0);

      return random;
    },
    PreviewTemplate() {
      this.imgCollection.map((item, index) => {
        // console.log(this.biasedRandom(1, 0.2), "bias");

        eval(`this.${this.Templatemap[item.Platform]}.push(item)`);
        return;
      });
      this.InstagramTemplate =
        this.InstagramTemplate[
          this.biasedRandom(this.InstagramTemplate.length - 1)
        ];

      this.isShowImage = eval(`this.${this.Templatemap["Instagram"]}`);
      console.log(this.isShowImage, "iMAGE");
      return;
    },
    LogoClick(item) {
      this.LogoMedia = item;
      this.centerDialogVisibleprimaryMedia = false;
    },
    ImageClick(item) {
      this.ImageMedia = item;
      this.centerDialogVisibleprimaryImage = false;
    },
    async Fetchmedia() {
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
      console.log(this.Fetchedmedias);
    },

    async handleUploadSuccess(name) {
      // this.centerDialogVisiblealternate = false;
      // this.centerDialogVisibleprimary = false;
      // this.centerDialogVisiblefavicon = false;
      if (this.ShowPopup) {
        this.$swal({
          title: "Success!",
          text: `File ${name} uploaded`,
          customClass: {
            container: "my-sweetalert-container",
          },
          icon: "success",
          // timer: 2000,
          buttons: false,
        });
      }
    },
    async beforeUpload(file) {
      console.log(file.name);
      let formData = new FormData();
      const fileType = file.type;
      formData.append("file", file);
      if (
        fileType.startsWith("image/jpeg") ||
        fileType.startsWith("image/png") ||
        fileType.startsWith("image/gif")
      ) {
        formData.append("type", "image");
      } else if (
        fileType.startsWith("video/mp4") ||
        fileType.startsWith("video/webm") ||
        fileType.startsWith("video/ogg")
      ) {
        formData.append("type", "video");
      } else if (fileType.startsWith("image/svg+xml")) {
        formData.append("type", "svg");
      } else {
        this.isShowDetailsAddons = false;
        this.$swal({
          title: "Error",
          text: `${file.type} not allowed`,
          icon: "error",
          timer: 5000,
          buttons: false,
        });
        return;
      }
      // let URL = process.env.VUE_APP_BASE_URL_CORE_API.split("/api/")[0];
      let URL = process.env.VUE_APP_PROJECTSTORAGE_URL;
      formData.append("Storeendpoint", URL);
      await this.uploadFile(formData, file.name);
      return false;
    },
    async uploadFile(formData, name) {
      await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Save",
        formData,
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.mediaCollection = mediaData.data;
      console.log(this.mediaCollection, "MEDIA");
      this.handleUploadSuccess(name);
    },
    handleUploadMedia() {
      this.centerDialogVisibleprimaryMedia = true;
      console.log("Media");
    },
    handleUploadImage() {
      this.centerDialogVisibleprimaryImage = true;
      console.log("Image");
    },
    handleTabClick(str) {
      this.Platform = str;
      console.log(this.Platform, "platform");
    },
    CancelEdit() {
      this.isShowContentEdit = false;
      this.search = "";
    },

    async getUpcoming(events) {
      console.log("promisecall");
      return new Promise((resolve, reject) => {
        try {
          console.log("call");
          const currentDate = new Date();
          // console.log(currentDate, "currentdate");
          const eventDates = events.map((event) => new Date(event.eventDate));

          function getDateDifference(date1, date2) {
            if (date1 - date2 < 0) {
              return Math.ceil(Math.abs(date1 - date2) / (1000 * 60 * 60 * 24));
            } else {
              return "past";
            }
          }
          let closestDate = "";
          let closestDateDifference = 0;
          console.log(closestDateDifference, "upcoming1");
          console.log(closestDateDifference, "upcoming");
          for (let i = 1; i < eventDates.length; i++) {
            const dataDifference = getDateDifference(
              currentDate,
              eventDates[i]
            );
            if (dataDifference == "past") {
              continue;
            } else {
              // console.log(closestDateDifference, dataDifference, "currentdate");
              // console.log(dataDifference, "upcoming");
              if (
                dataDifference < closestDateDifference ||
                closestDateDifference == 0
              ) {
                console.log(eventDates[i], currentDate, "currentdate");
                closestDate = eventDates[i];
                closestDateDifference = dataDifference;
                // console.log(closestDate, "currentdate");
              }
            }
          }
          const closestEvent = events.find(
            (event) =>
              new Date(event.eventDate).toISOString() ===
              closestDate.toISOString()
          );

          // closestDate = closestDate.toISOString();
          console.log(closestEvent, "getupcoming");
          resolve(closestEvent);
        } catch (error) {
          console.log(error, "getupcoming");
          reject(error);
        }
      });
    },
    async getEvents() {
      const { data } = await this.$store.dispatch("admin/getEvents", {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      });
      console.log(data.data, "upcoming");
      const events = data.data.map(
        (x, index) => {
          return {
            ...x,
          };
        }

        // for (let index = 0; index < events.length; index++) {

        // }
      );
      // this.eventsCard = events[0];
      let upcomingevent;
      try {
        upcomingevent = await this.getUpcoming(events);
        console.log(upcomingevent, "upcoming");
      } catch (error) {
        this.NoUpcoming = true;
      }

      console.log(this.NoUpcoming, "Noupcoming");
      this.Heading = upcomingevent.title;
      this.Paragraph = upcomingevent.subtitle;
      this.eventsCard = [];
      this.eventsCard.push(upcomingevent);
      console.log(events, "upcoming");
      console.log(this.eventsCard, "upcoming");
      let postData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Posts" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      console.log(postData);
      this.postData = postData.data;
      this.eventsCard.map((item1, index1) => {
        const index2 = postData.data.findIndex(
          (item2) =>
            item1.title === item2.EventTitle && item2.Platform === "Instagram"
        );

        if (index2 != -1) {
          console.log(postData.data[index2].link);
          this.Posts =
            process.env.VUE_APP_IMAGE_URL + "/" + postData.data[index2].link;
        }

        //  return index2 != -1 ? [index1, index2] : null;
      });

      console.log(this.Posts, "Posts");

      console.log(events, "Events");
      console.log(this.eventsCard, "Events");
    },
    async getBrandProfile() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = this.$store.dispatch("brandProfile/getBrandProfile", payload);
      this.brand = this.brandProfile;
    },
    setLayout(index) {
      console.log();
      // for (let index = 0; index < this.eventsCard.length; index++) {
      if (index < 9) {
        return this.layoutSelected.layout.includes(index);
      } else {
        const layout = index % 9;
        return this.layoutSelected.layout.includes(layout);
      }
      // }
    },

    async updateDetails() {
      if (this.LogoMedia == "" || this.ImageMedia == "") {
        this.$swal({
          title: "Error",
          text: `Both the images need to be selected`,
          customClass: {
            container: "my-sweetalert-container",
          },
          icon: "error",
          timer: 2000,
          buttons: false,
        });
        return;
      }
      let loader = this.$loading({
        lock: true,
        text: "Creating",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // this.centerDialogVisibleprimaryMedia = true;
      // console.log(this.isShowImage);
      this.layoutPriview = this.isShowImage;
      console.log(
        this.url + "/" + this.LogoMedia.link,
        this.url + "/" + this.ImageMedia.link
      );
      await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Posts" + "/Delete",
        {
          title: this.eventsCard[0].title,
          platform: this.Platform,
        },
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      let url = await axios.post(
        process.env.VUE_APP_BRANDING_API + "api/v1/post",
        {
          id: this.isShowImage.id,
          image: [
            this.url + "/" + this.LogoMedia.link,
            this.url + "/" + this.ImageMedia.link,
          ],
          text: [this.Heading, this.Paragraph, this.Website, this.Email],
          fontColors: [
            this.text1Color,
            this.text2Color,
            this.text3Color,
            this.text4Color,
          ],
          brandName: process.env.VUE_APP_COMMUNITY_NAME,
          fontFamily: [
            this.primaryFont,
            this.ParagraphFont,
            this.ParagraphFont,
            this.ParagraphFont,
          ],
          rotation_image: this.rotation_image,
          Coords_image: this.Coords_image,
          Coords_text: this.Coords_text,
          primary: this.Primary,
          secondary: this.Secondary,
          platform: this.Platform,
        }
      );

      // this.layoutPriview = {
      //   img : this.isShowImage,
      //   id : this.id
      // }
      // console.log(url);
      console.log(url);
      let binaryData = atob(url.data);
      const ab = new ArrayBuffer(binaryData.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < binaryData.length; i++) {
        ia[i] = binaryData.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: "image/jpeg" });
      const formData = new FormData();
      formData.append("file", blob, `${Math.random()}.jpeg`);
      formData.append("Platform", this.Platform);
      formData.append("EventTitle", this.eventsCard[0].title);
      // let URL = process.env.VUE_APP_BASE_URL_CORE_API.split("/api/")[0];
      let URL = process.env.VUE_APP_PROJECTSTORAGE_URL;
      formData.append("Storeendpoint", URL);
      await axios.all([
        await axios.post(
          process.env.VUE_APP_SVG_DATAENTRY + "/Posts" + "/Save",
          formData,

          {
            headers: {
              "community-name": process.env.VUE_APP_COMMUNITY_NAME,
            },
          }
        ),

        await axios.post(
          process.env.VUE_APP_SVG_DATAENTRY + "/Posts" + "/Update",
          {
            Platform: this.Platform,
            EventTitle: this.eventsCard[0].title,
            id: this.isShowImage.id,
            image: [this.LogoMedia.link, this.ImageMedia.link],
            text: [this.Heading, this.Paragraph, this.Website, this.Email],
            fontColors: ["black", "black", "black", "black"],
            brandName: process.env.VUE_APP_COMMUNITY_NAME,
            fontFamily: [
              this.primaryFont,
              this.ParagraphFont,
              this.ParagraphFont,
              this.ParagraphFont,
            ],
            rotation_image: this.rotation_image,
            Coords_image: this.Coords_image,
            Coords_text: this.Coords_text,
            primary: this.Primary,
            secondary: this.Secondary,
            textColors: [
              this.text1Color,
              this.text2Color,
              this.text3Color,
              this.text4Color,
            ],
          },
          {
            headers: {
              "community-name": process.env.VUE_APP_COMMUNITY_NAME,
            },
          }
        ),
      ]);

      // this.Posts[this.parentIndex] = "data:image/png;base64, " + url.data;
      if (this.Platform === "Instagram") {
        this.Posts = "data:image/png;base64, " + url.data;
      }

      console.log(this.Posts);
      this.isShowContentEdit = false;
      let postData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Posts" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      console.log(postData);
      this.postData = postData.data;
      await this.PopulatePreview();
      loader.close();
    },

    async ShowUpdate(index) {
      this.isCanvasSupplied = false;
      this.currentStep = 1;
      this.search = "";
      console.log(index);
      await this.getBrandProfile();
      this.Primary = this.brand.primaryColor;
      this.Secondary = this.brand.secondaryColor;
      this.Email = this.brand.contactDetails.email;
      this.Website = this.brand.contactDetails.url;
      console.log(this.brand);
      this.ParagraphFont = this.brand.secondaryFont;
      this.primaryFont = this.brand.primaryFont;

      // this.Heading = this.eventsCard[index].title;
      // this.Paragraph = this.eventsCard[index].subtitle;
      // this.parentIndex = index;

      this.isShowContentEdit = true;

      this.LogoMedia = "";
      this.ImageMedia = "";
      console.log(this.postData, "postdata");

      let mappedPost = this.postData.map(async (item, index1) => {
        if (
          item.EventTitle == this.eventsCard[0].title &&
          item.Platform == "Instagram"
        ) {
          this.PostsAlreadyexsists = true;
          console.log("yes", "postdata");
          let { data } = await axios
            .post(
              process.env.VUE_APP_SVG_DATAENTRY + "/Templates" + "/Readone",
              {
                id: item.id,
              }
            )
            .then((response) => {
              return response;
            });
          console.log(item.image[0], "postdata");
          console.log(item.image[1], "postdata");
          console.log(data.response[0], "postdata");
          this.FetchedLayout = null;
          let link = "link";
          this.isShowImage = data.response[0];
          // eval(`this.${this.Templatemap[this.Platform]}= data.response[0];`);

          console.log(item.image[0], "postdata");
          console.log(item.image[1], "postdata");
          console.log(this.LogoMedia, "postdata");
          console.log(this.ImageMedia, "postdata");
          this.Heading = item.text[0];
          this.Paragraph = item.text[1];
          this.Website = item.text[2];
          this.Email = item.text[3];

          this.rotation_image = item.rotation_image;
          this.Coords_image = item.Coords_image;
          this.Coords_text = item.Coords_text;
          if (item.brandName == "base-admin") {
            console.log("Campaign_default");
            this.Primary = this.brand.primaryColor;
            this.Secondary = this.brand.secondaryColor;
            this.LogoMedia = { link: this.brand.primaryLogo };
            this.ImageMedia = { link: item.image[1] };
          } else {
            this.Primary = item.primary;
            this.Secondary = item.secondary;
            this.LogoMedia = { link: item.image[0] };
            this.ImageMedia = { link: item.image[1] };
          }

          // this.Platform = item.platform;
          console.log(item.textColors, "Color");
          if (item.textColors.length != 0) {
            this.text1Color = item.textColors[0];
            this.text2Color = item.textColors[1];

            this.text3Color = item.textColors[2];
            this.text4Color = item.textColors[3];
          }

          // this.primaryFont = item.fontFamily[0];
          // this.ParagraphFont = item.fontFamily[1];

          for (let i = 0; i <= this.mediaCollection.length - 1; i++) {
            if (this.mediaCollection[i].link == this.LogoMedia.link) {
              this.LogoMedia["_id"] = this.mediaCollection[i]._id;
            }
            if (this.mediaCollection[i].link == this.ImageMedia.link) {
              this.ImageMedia["_id"] = this.mediaCollection[i]._id;
            }
          }
          console.log(this.LogoMedia, this.ImageMedia, "damn");
          // try {
          //   await fontMachine([this.ParagraphFont, this.primaryFont]);
          // } catch (error) {
          //   console.log("error");
          // }
          await this.PreviewCanvas();
          this.isCanvasSupplied = true;
          this.primaryFont = item.fontFamily[0];
          this.ParagraphFont = item.fontFamily[1];
          console.log("hi");
        }

        // }
      });
      console.log(!this.CanvasSupplied, "Nope");
      Promise.all(mappedPost).then(async () => {
        if (!this.isCanvasSupplied) {
          console.log("Nope");
          this.PostsAlreadyexsists = false;
          await this.PreviewCanvas();
          this.isCanvasSupplied = true;
        }
      });
    },

    async PopulatePreview(index) {
      this.isShowContentEdit = false;
      this.isCanvasSupplied = false;
      let postData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Posts" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      console.log(postData);
      this.postData = postData.data;
      this.eventsCard.map((item1, index1) => {
        const index2 = postData.data.findIndex(
          (item2) =>
            item1.title === item2.EventTitle && item2.Platform === "Instagram"
        );

        if (index2 != -1) {
          console.log(postData.data[index2].link);
          this.Posts =
            process.env.VUE_APP_IMAGE_URL + "/" + postData.data[index2].link;
        }

        //  return index2 != -1 ? [index1, index2] : null;
      });

      this.currentStep = 1;
      this.search = "";
      console.log(index);
      await this.getBrandProfile();
      this.Primary = this.brand.primaryColor;
      this.Secondary = this.brand.secondaryColor;
      this.Email = this.brand.contactDetails.email;
      this.Website = this.brand.contactDetails.url;
      console.log(this.brand);
      // this.ParagraphFont = this.brand.secondaryFont;
      // this.primaryFont = this.brand.primaryFont;

      // this.Heading = this.eventsCard[index].title;
      // this.Paragraph = this.eventsCard[index].subtitle;
      // this.parentIndex = index;

      this.LogoMedia = "";
      this.ImageMedia = "";
      console.log(this.postData, "postdata");

      let mappedPost = this.postData.map(async (item, index1) => {
        if (
          item.EventTitle == this.eventsCard[0].title &&
          item.Platform == "Instagram"
        ) {
          this.PostsAlreadyexsists = true;
          console.log("yes", "postdata");
          let { data } = await axios
            .post(
              process.env.VUE_APP_SVG_DATAENTRY + "/Templates" + "/Readone",
              {
                id: item.id,
              }
            )
            .then((response) => {
              return response;
            });
          console.log(item.image[0], "postdata");
          console.log(item.image[1], "postdata");
          console.log(data.response[0], "postdata");
          this.FetchedLayout = null;
          let link = "link";
          this.isShowImage = data.response[0];
          // eval(`this.${this.Templatemap[this.Platform]}= data.response[0];`);

          console.log(item.image[0], "postdata");
          console.log(item.image[1], "postdata");
          console.log(this.LogoMedia, "postdata");
          console.log(this.ImageMedia, "postdata");
          this.Heading = item.text[0];
          this.Paragraph = item.text[1];
          this.Website = item.text[2];
          this.Email = item.text[3];

          this.rotation_image = item.rotation_image;
          this.Coords_image = item.Coords_image;
          this.Coords_text = item.Coords_text;
          if (item.brandName == "base-admin") {
            this.Primary = this.brand.primaryColor;
            this.Secondary = this.brand.secondaryColor;
            this.LogoMedia = { link: this.brand.primaryLogo };
            this.ImageMedia = { link: item.image[1] };
          } else {
            this.Primary = item.primary;
            this.Secondary = item.secondary;
            this.LogoMedia = { link: item.image[0] };
            this.ImageMedia = { link: item.image[1] };
          }

          // this.Platform = item.platform;
          console.log(item.textColors, "Color");
          if (item.textColors.length != 0) {
            this.text1Color = item.textColors[0];
            this.text2Color = item.textColors[1];

            this.text3Color = item.textColors[2];
            this.text4Color = item.textColors[3];
          }

          // this.primaryFont = item.fontFamily[0];
          // this.ParagraphFont = item.fontFamily[1];

          for (let i = 0; i <= this.mediaCollection.length - 1; i++) {
            if (this.mediaCollection[i].link == this.LogoMedia.link) {
              this.LogoMedia["_id"] = this.mediaCollection[i]._id;
            }
            if (this.mediaCollection[i].link == this.ImageMedia.link) {
              this.ImageMedia["_id"] = this.mediaCollection[i]._id;
            }
          }
          console.log(this.LogoMedia, this.ImageMedia, "damn");
          // try {
          //   await fontMachine([this.ParagraphFont, this.primaryFont]);
          // } catch (error) {
          //   console.log("error");
          // }
          await this.PreviewCanvas();
          this.isCanvasSupplied = true;
          this.primaryFont = item.fontFamily[0];
          this.ParagraphFont = item.fontFamily[1];
          console.log("hi");
        }

        // }
      });
      console.log(!this.CanvasSupplied, "Nope");
      Promise.all(mappedPost).then(async () => {
        if (!this.isCanvasSupplied) {
          console.log("Nope");
          this.PostsAlreadyexsists = false;
          await this.PreviewCanvas();
          this.isCanvasSupplied = true;
        }
      });
    },
    async Platformname(str) {
      if (this.Platform != str) {
        this.$set(this, "Platform", str);
        this.Coords_image = [null, null];
        this.Coords_text = [null, null, null, null];
        this.rotation_image = [0, 0];

        this.isShowImage = eval(`this.${this.Templatemap[str]}`);
        this.FetchedLayout = null;
        // this.Platform = str;
        console.log(this.Platform, "platform");
        console.log(this.imgCollection);
        // await this.PreviewCanvas();
      }
    },
    async GenerateHandP() {
      console.log(this.selectedPlan[0]["subscription"]["name"], "Plan");
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        planName: this.selectedPlan[0]["subscription"]["name"],
      };
      await this.$store.dispatch("brandProfile/Ailimit", payload);
      if (this.ailimit > 0) {
        if (this.Prompt != "") {
          const { data } = await axios.post(
            process.env.VUE_APP_API_BUILDER + "/Recommendation_v1",
            {
              string: `only title, subtitle, caption for a ${this.Prompt} in array format`,
            }
          );

          console.log(data, "answer");
          this.Heading = data[0];
          this.Paragraph = data[1];
        } else {
          this.$swal({
            title: "Error",
            text: `Prompt is empty`,
            customClass: {
              container: "my-sweetalert-container",
            },
            icon: "error",
            timer: 2000,
            buttons: false,
          });
        }
      } else {
        this.$swal({
          title: "Error",
          text: `Ai limit reached`,
          customClass: {
            container: "my-sweetalert-container",
          },
          icon: "error",
          timer: 2000,
          buttons: false,
        });
      }
    },
    async GetKeywordforImage() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        planName: this.selectedPlan[0]["subscription"]["name"],
      };

      await this.$store.dispatch("brandProfile/Ailimit", payload);
      if (this.ailimit > 0) {
        console.log(this.search, "key");
        if (this.search != "") {
          const { data } = await axios.post(
            process.env.VUE_APP_API_BUILDER + "/Recommendation_v1",
            {
              string: `give two one word keyword based on the main topic of title ${this.search} in an array format`,
            }
          );
          console.log(data.join("+"), "key");
          return data.join("+");
        } else {
          this.$swal({
            title: "Error",
            text: `Prompt is empty`,
            customClass: {
              container: "my-sweetalert-container",
            },
            icon: "error",
            timer: 2000,
            buttons: false,
          });
        }
      } else {
        this.$swal({
          title: "Error",
          text: `Ai limit reached`,
          customClass: {
            container: "my-sweetalert-container",
          },
          icon: "error",
          timer: 2000,
          buttons: false,
        });
      }
    },
    async ClickonPixabay(url) {
      if (this.OnlineSelectedImages.includes(url)) {
        this.OnlineSelectedImages = this.OnlineSelectedImages.filter((ele) => {
          return ele != url;
        });
      } else {
        this.OnlineSelectedImages.push(url);
      }

      console.log(this.OnlineSelectedImages, "Pixabay");
    },
    async RequestToPixabay() {
      if (this.search == "") {
        this.search = this.eventsCard[0].title;
      }
      let Query;
      if (this.search.includes("+") || /^[A-Za-z]+$/.test(this.search)) {
        Query = this.search;
        let { data } = await axios.get(
          `https://pixabay.com/api/?key=39578732-274d7b5c2f1a93b01f9792f95&q=${Query}&safesearch=true&order=latest`
        );
        console.log(data.hits, "Pixabay");
        this.OnlineImages = data.hits;
      } else {
        this.$swal
          .fire({
            title: "Alert",
            text: "Ai will be used to proccess a natural langauge query, to avoid this search in the format of for example 'Yellow+flower' (adding + between words) if you wish to excercise your Ai credits click Confirm",
            icon: "warning",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            showCancelButton: true,
            confirmButtonColor: "#EA4Dff",
            cancelButtonColor: "  #6e7881",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              Query = await this.GetKeywordforImage();
              this.search = Query;
              let { data } = await axios.get(
                `https://pixabay.com/api/?key=39578732-274d7b5c2f1a93b01f9792f95&q=${Query}&safesearch=true&order=latest`
              );
              console.log(data.hits, "Pixabay");
              this.OnlineImages = data.hits;
            }
          });
      }

      // let Query = this.search;
    },

    async SaveUsingRemote(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const filename = url.substring(url.lastIndexOf("/") + 1);
      const file = new File([blob], filename, { type: blob.type });
      await this.beforeUpload(file);
    },
  },
  components: {
    ExploreWeb3,
    RecommendedUpgrade,
    MyResources,
  },
};
